import { BaseModel } from '../base-model'
import { ProcedureCodeModifierData } from './procedure-code-modifier.data'

export class ProcedureCodeModifier extends BaseModel {
  code: string
  abbreviation: string

  constructor(data: ProcedureCodeModifierData) {
    super(data, true)
  }
}
